import { getEndOfDay } from './getEndOfDay';
/**
 * @description Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date} date The date to find end of month of.
 *
 * @returns {Date} Date of the end of month.
 */
export var getEndOfMonth = function (date) {
    var dateToMutate = new Date(date);
    var month = dateToMutate.getMonth();
    dateToMutate.setFullYear(dateToMutate.getFullYear(), month + 1, 0);
    var endOfMonth = getEndOfDay(dateToMutate);
    return endOfMonth;
};
//# sourceMappingURL=getEndOfMonth.js.map